module.exports = __webpack_public_path__ + "img/prevent-0-pic.845ecc85.jpg";